module.exports = __webpack_public_path__ + "img/1L3FocuFS6mVUBcURBYCiFP_3Qdmc00HX.a0e11fcf.png";